import { fa } from '../i18n/fa';

/**
 * A chart panel: title, fixed-height chart surface (or its empty state) and an
 * optional footnote. Keeping this in one place keeps the six chart cards the
 * same size and the empty states identical.
 */
export default function ChartCard({
    title,
    note,
    empty,
    emptyMessage = fa.empty.chart,
    children,
    className = '',
}) {
    return (
        <div className={`tr-card tr-panel ${className}`.trim()}>
            <h2 className="tr-title">{title}</h2>
            {empty ? (
                <div className="tr-empty">
                    <i className="fas fa-chart-line" aria-hidden="true" />
                    <p>{emptyMessage}</p>
                </div>
            ) : (
                <div className="tr-cw">{children}</div>
            )}
            {note && <p className="tr-note">{note}</p>}
        </div>
    );
}
